<template>
  <div class="page-wrapper">
    <SideNav />

    <div class="container">
      <PortalHeader
        :shrink="shrinkHeaderActive"
        :shrink-height="shrinkHeaderHeight"
      />

      <main ref="content">
        <slot>
          <router-view class="inner-content" />
        </slot>
      </main>
    </div>

    <TutorialModal />
  </div>
</template>

<script>
import SideNav from './SideNav.vue';
import PortalHeader from './PortalHeader.vue';
import TutorialModal from './TutorialModal.vue';

export default {
  components: {
    SideNav,
    PortalHeader,
    TutorialModal,
  },
  data: () => ({
    shrinkHeaderActive: false,
    shrinkHeaderHeight: 50,
    shrinkHeaderTrigger: 150,
  }),
  created() {
    this.$nextTick(() => {
      this.$refs.content.addEventListener('scroll', () => {
        if (this.shrinkHeaderActive
          && this.$refs.content.scrollTop
            <= this.shrinkHeaderTrigger - this.shrinkHeaderHeight - 1) {
          this.shrinkHeaderActive = false;
        } else if (!this.shrinkHeaderActive && this.$refs.content.scrollTop
            > this.shrinkHeaderTrigger) {
          this.shrinkHeaderActive = true;
        }
      });
    });
  },
};
</script>

<style scoped>
.page-wrapper {
  height: 100%;
  display: flex;
  flex-direction: row;
}
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
main {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
}
.content {
  width: 100%;
  display: block;
  justify-content: center;
}
.inner-content {
  min-height: 0 !important;
  width: 100%;
}
</style>
